<template>
  <div class="flex flex-col items-center justify-end text-xl uppercase sm:text-2xl">
    <div class="relative flex flex-col items-center justify-end overflow-hidden">
      <transition-group
        move-class="transition-all ease-in-out duration-500"
        enter-active-class="transition-all ease-in-out duration-500"
        leave-active-class="transition-all ease-in-out duration-500 absolute top-0"
        leave-to-class="opacity-0! -translate-y-4"
        enter-from-class="opacity-0! translate-y-4"
      >
        <div v-for="({ index: entryIdx, value, icon }, i) in historyItems" :key="entryIdx">
          <slot name="history-entry" :i="i" :entry="value">
            <div
              class="-mb-0.5 scale-75 text-center"
              :style="{
                opacity: (1 / (historyItems.length + 1)) * (i + 1),
                filter: `blur(${historyItems.length - 1 - i}px)`,
              }"
            >
              <span class="mr-2">{{ value }}</span>
              <font-awesome-icon :icon="icon" />
            </div>
          </slot>
        </div>
      </transition-group>
    </div>
    <slot v-if="currentItem" name="current-entry">
      <div class="items-center text-center font-bold">
        <span class="mr-2">{{ currentItem }}</span>
        <font-awesome-icon v-if="currentItemIcon" :icon="currentItemIcon" />
        <font-awesome-icon v-else-if="lostFocus" :icon="faXmark" />
        <font-awesome-icon v-else :icon="faSpinnerThird" spin />
      </div>
    </slot>
  </div>
</template>

<script setup lang="ts">
import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { faSpinnerThird, faXmark } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { computed } from "vue";
import { useServiceStore } from "../../store/service";

const service = useServiceStore();

const lostFocus = computed(() => service.lostFocus);

defineProps<{
  currentItem?: string;
  currentItemIcon?: IconDefinition;
  historyItems: Array<{ index: number; value: string; icon: IconDefinition }>;
}>();
</script>
